import { adDark } from '../../assets/theme/ad/dark';
import { adLight } from '../../assets/theme/ad/light';
import { etoroLight } from '../../assets/theme/etoro/light';
import { genistarLight } from '../../assets/theme/genistar/light';
import { mfDark } from '../../assets/theme/mf/dark';
import { mfLight } from '../../assets/theme/mf/light';
import { mf2023Dark } from '../../assets/theme/mf-2023/dark';
import { mf2023Light } from '../../assets/theme/mf-2023/light';
export var getImagesByTheme = function (theme) {
  switch (theme) {
    case 'mf':
    case 'mf-light':
      return mfLight;
    case 'mf-dark':
      return mfDark;
    case 'mf-2023-dark':
      return mf2023Dark;
    case 'mf-2023-light':
      return mf2023Light;
    case 'ad-light':
      return adLight;
    case 'ad-dark':
      return adDark;
    case 'etoro-light':
      return etoroLight;
    case 'genistar-light':
      return genistarLight;
  }
};
export var getImageURIByTheme = function (t, k) {
  return "url('data:image/svg+xml;utf8,".concat(encodeURIComponent(getImagesByTheme(t)[k]), "')");
};